/**
 * Q-1801 S5: the only texts /login may show for `?error=`. The query string picks a CODE; the message is ours.
 * Anything not in this table (including every `error_description`) shows GENERIC_LOGIN_ERROR, so a crafted
 * /login?error=<sentence> cannot put attacker-chosen words on our login card. Same shape as A70's `?reason=`.
 */
export const GENERIC_LOGIN_ERROR = 'We could not sign you in. Please try again.'

export const LOGIN_ERROR_MESSAGES: Readonly<Record<string, string>> = Object.freeze({
    unauthorized: 'You are not authorized to view that page. Please sign in with an authorized account.',
    access_denied: 'Sign-in was cancelled or not permitted. Please try again.',
    auth_failed: 'Authentication failed. Please try again.',
    exchange_failed: 'We could not complete your sign-in. Please try again.',
    domain_not_allowed: 'This email address is not allowed for officer login.',
    unauthorized_origin: 'Sign-in from this location is not permitted.',
})

export function loginErrorMessage(code: string | null | undefined): string {
    if (code && Object.prototype.hasOwnProperty.call(LOGIN_ERROR_MESSAGES, code)) return LOGIN_ERROR_MESSAGES[code]
    return GENERIC_LOGIN_ERROR
}

/** The code for an OAuth `?error=` the provider returned to the callback; its text is logged, never forwarded. */
export function providerLoginErrorCode(providerError: string | null | undefined): string {
    return providerError === 'access_denied' ? 'access_denied' : 'auth_failed'
}
